import { Grid, styled } from "@mui/material";

export const DescriptionSide = styled(Grid)(({ theme }) => ({
  width: "100%",
  maxWidth: theme.spacing(45),
  display: "flex",
  flexDirection: "column",
}));